import {
    GET_ALL_APPOINTMENTS,
    GET_ALL_APPOINTMENTS_AUCTION,
    GET_SINGLE_APPOINTMENT,
    GET_ALL_LOCATIONS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_CALENDARS,
} from './appointmentTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_APPOINTMENTS:
            return {
                ...state,
                all_appointments: action.payload,
            }
        case GET_SINGLE_APPOINTMENT:
            return {
                ...state,
                single_appointment: action.payload,
            }
        case GET_ALL_APPOINTMENTS_AUCTION:
            return {
                ...state,
                all_appointments_auction: action.payload,
            }
        case GET_ALL_LOCATIONS:
            return {
                ...state,
                all_locations: action.payload,
            }
        case GET_ALL_CALENDARS:
            return {
                ...state,
                all_calendars: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
